<template>
  <section>
    <div class="vagas">
      <div
        v-for="vaga in vagas"
        :key="vaga.id"
        :class="{vaga:true, esgotada:!vaga.value}"
        @click="abrir(vaga.title, vaga.value)"
      >
        <span class="titulo">{{vaga.title}}</span>
        <br>
        <!--
        <span v-if="vaga.value" class="texto">
          vagas<small>disponíveis</small>
        </span>
        <span v-else class="texto">
          <small>vagas</small>esgotadas
        </span>
        -->
        <!-- <span class="numero">
          09
          <small>vagas</small>
        </span>-->
        <span class="acao" v-if="vaga.value">Tenho Interesse</span>
        <span class="acao" v-else>Lista de Espera</span>
      </div>
    </div>
    <v-dialog v-model="dialog" width="500" :persistent="true">
      <v-card>
        <!-- <v-card-title class="headline grey lighten-2" primary-title>{{cliente.turma}}</v-card-title> -->
        <v-toolbar card dark color="primary">
          <v-toolbar-title>{{cliente.turma}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="fechar()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <div v-if="enviada">
            <p class="lead">Muito obrigado, {{cliente.name}}!</p>
            <p
              v-if="temVaga"
            >Recebemos os seus dados e logo entraremos em contato para efetivação da matrícula.</p>
            <p
              v-else
            >Você foi adicionado em nossa lista de espera. Caso alguma vaga seja liberada entraremos em contato.</p>
            <v-card-actions class="text-xs-center">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat block @click="fechar()">voltar</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </div>
          <div v-if="!enviada">
            <p
              v-if="temVaga"
              style="text-align:left"
            >Informe os dados do responsável e nós entraremos em contato para oferecer uma vaga nesta turma:</p>
            <p
              v-else
              style="text-align:left"
            >Informe seus dados para entrar na lista de espera desta turma.</p>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    name="nome"
                    v-model="cliente.name"
                    :rules="rules.name"
                    label="Seu nome"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    name="telefone"
                    v-model="cliente.phone"
                    :rules="rules.phone"
                    label="Seu telefone"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    name="email"
                    v-model="cliente.email"
                    type="email"
                    :rules="rules.email"
                    label="Seu email (opcional)"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-select
                    v-model="cliente.origem"
                    :items="['Pesquisando no Google', 'Publicidade em outdoor', 'Publicidade em sites', 'Publicidade de jornal impresso', 'Indicação', 'Outros']"
                    :rules="rules.origem"
                    label="Como ficou sabendo de nós?"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 md12 v-if="cliente.origem == 'Outros'">
                  <v-text-field
                    v-model="cliente.outro"
                    :rules="rules.outro"
                    label="Conte aqui como ficou sabendo de nós"
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 md12>
                  <v-textarea
                    v-model="cliente.message"
                    label="Se preferir, escreva alguma mensagem (opcional)"
                  ></v-textarea>
                </v-flex>-->
              </v-layout>
            </v-form>
          </div>
        </v-card-text>

        <v-divider v-if="!enviada"></v-divider>

        <v-card-actions v-if="!enviada">
          <v-btn
            block
            depressed
            large
            style="color:white !important;"
            color="blue"
            @click.prevent="enviar()"
          >{{enviando?"Enviando...":"Registrar interesse"}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import PostService from "../../services/PostService";

export default {
  data: () => ({
    vagas: [],
    dialog: false,
    enviando: false,
    enviada: false, // true quando a mensagem foi enviada
    valid: true,
    temVaga: true,
    // errors: null,
    cliente: {
      turma: null,
      name: null,
      email: null,
      phone: null,
      origem: null
    },
    rules: {
      name: [v => !!v || ""],
      // email: [v => !!v || "", v => /.+@.+/.test(v) || "E-mail inválido"],
      phone: [v => !!v || ""],
      origem: [v => !!v || ""],
      outro: [v => !!v || ""]
    }
  }),
  // props: ["value"],
  created: function() {
    this.vagas = [
      { id: 1, title: "Ed. Infantil", value: 3 },
      { id: 2, title: "1º Ano", value: 5 },
      { id: 3, title: "2º Ano", value: 5 },
      { id: 4, title: "3º Ano", value: 5 },
      { id: 5, title: "4º Ano", value: 5 },
      { id: 6, title: "5º Ano", value: 5 },
      { id: 7, title: "6º Ano", value: 5 },
      { id: 8, title: "7º Ano", value: 5 },
      { id: 9, title: "8º Ano", value: 5 },
      { id: 10, title: "9º Ano", value: 5 }
    ];
  },
  methods: {
    abrir: function(turma, vagas) {
      this.dialog = true;
      this.temVaga = vagas > 0;
      this.cliente.turma = turma;
    },
    fechar: function() {
      this.dialog = false;
      this.valid = true;
      this.cliente.turma = null;
      this.enviada = false;
    },
    enviar: function() {
      let self = this;
      self.enviando = true;
      console.log("Produto.enviar()");
      let srvPost = new PostService();
      console.log("srvPost", srvPost);
      if (typeof Storage !== "undefined") {
        localStorage.setItem("cliente", JSON.stringify(this.cliente));
      } else {
        console.log("Sem suporte a localStorage.getItem()");
      }
      if (self.$refs.form.validate()) {
        srvPost.submit(this.cliente, function(response) {
          self.enviando = false;
          console.log("response: ", response);
          if (response.classe === "Eliti_Response_Success_Message") {
            console.log("Eliti_Response_Success_Message...");
            self.enviada = true;
          }

          // if(response.classe === "Eliti_Response_Error_Validation") {
          //   console.log("Eliti_Response_Error_Validation...");
          //   this.errors = response.errors;
          // }
        });
      } else {
        self.enviando = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$color-darker: #df6e01;
$color-default: #ef7e21;
$color-light: #f79a3a;

@mixin gradient-horizontal($startColor: #555, $endColor: #333) {
  background-color: $endColor;
  background-image: -moz-linear-gradient(
    left,
    $startColor,
    $endColor
  ); // FF 3.6+
  background-image: -webkit-gradient(
    linear,
    0 0,
    100% 0,
    from($startColor),
    to($endColor)
  ); // Safari 4+, Chrome 2+
  background-image: -webkit-linear-gradient(
    left,
    $startColor,
    $endColor
  ); // Safari 5.1+, Chrome 10+
  background-image: -o-linear-gradient(
    left,
    $startColor,
    $endColor
  ); // Opera 11.10
  background-image: linear-gradient(
    to right,
    $startColor,
    $endColor
  ); // Standard, IE10
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#{ie-hex-str($startColor)}', endColorstr='#{ie-hex-str($endColor)}', GradientType=1); // IE9 and down
}

.vagas {
  display: flex;
  text-align: center;
  flex-flow: row wrap;
}

.vaga {
  color: white;
  @include gradient-horizontal($color-darker, $color-default);
  // background: $color-default;
  text-decoration: none;
  padding: 20px 5px;
  border-bottom: 5px solid white;
  transition: 0.4s;
  flex: 50%;
  &:hover {
    cursor: pointer;
    background: $color-light;
    .acao {
      background: white;
      color: $color-default;
    }
  }
  &.esgotada {
    @include gradient-horizontal(#666, #999);
    &:hover {
      @include gradient-horizontal(#777, #bbb);
    }
  }
}

.titulo,
.numero,
.texto {
  text-transform: uppercase;
  white-space: nowrap;
  font-weight: 700;
}

.texto {
  display: block;
  text-transform: uppercase;
  white-space: nowrap;
  font-weight: 700;
  line-height: 1em;
  font-size: 25px;
  padding: 15px 0;
  small {
    display: block;
    font-size: 20px;
  }
}

.titulo {
  font-size: 20px;
}

.numero {
  display: none;
  padding: 10px 0 5px 0;
  font-size: 40px;
  line-height: 25px;
  small {
    display: block;
    font-size: 13px;
  }
}

.acao {
  display: inline-block;
  padding: 3px 10px;
  color: white;
  border-radius: 20px;
  text-transform: uppercase;
  font-weight: 700;
  border: 2px solid white;
  transition: 0.2s;
}

// // XS
// @media screen and (max-width: 600px) {
//   .vaga {
//     flex: 20%;
//   }
// }

// SM
@media screen and (max-width: 960px) and (min-width: 601px) {
  .vaga {
    flex: 50%;
  }
}

// MD
@media screen and (max-width: 1264px) and (min-width: 961px) {
  .vaga {
    flex: 25%;
  }
}

// LG
@media screen and (max-width: 1904px) and (min-width: 1265px) {
  .vaga {
    flex: 20%;
  }
}

// XL
@media screen and (min-width: 1905px) {
  .vaga {
    flex: 20%;
  }
}
</style>

